// extracted by mini-css-extract-plugin
export var body = "_e0-0";
export var sectionHeader = "_e0-4";
export var shortcutColumns = "_e0-2";
export var shortcutList = "_e0-1";
export var shortcutSection = "_e0-3";